import { create } from 'zustand';
import { getState, useState } from '@/framework';
import type { IBrushDrawConfig, IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 绘制配置 */
    drawConfig: IBrushDrawConfig | null;
    /** 绘制配置代际，同一配置对象重新打开也会递增 */
    drawConfigVersion: number;
}

/** 动作 */
interface IAction {
    /** 设置绘制配置 */
    setDrawConfig: (drawConfig: IBrushDrawConfig | null) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        drawConfig: null,
        drawConfigVersion: 0,
    };
}

/** 创建存储 */
const createState = (_identity: string) => {
    const store = create<IStore>((set) => ({
        ...getInitialState(),

        setDrawConfig(drawConfig) {
            set((state) => ({ drawConfig, drawConfigVersion: state.drawConfigVersion + 1 }));
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'brush-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useBrushLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getBrushLayerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
